export default __webpack_public_path__ + "static/media/group-option-noglasses-unselected.f5738ef3.svg";